import React from 'react';
import { Widget } from './Widget';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DocumentState from '../../shared/model/DocumentState';
import PropTypes from 'prop-types';
import './Widgets.css';
import { DashboardTask } from './dashboard/DashboardTask';
import { PsWidgets } from './PsWidgets';
import Alert from 'react-s-alert';
import { DashboardRequest } from './dashboard/DashboardRequest';

export class Widgets extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            widgets: PsWidgets.null(),
        };
    }

    componentDidMount() {
        this.dashboard();
    }

    render() {
        const { widgets } = this.state;
        const { onFilter } = this.props;

        return (
            <div className="ps-home-widgets">
                <Widget
                    icon="person_add"
                    title={I18nUtils.tr('TR_TODOS').toUpperCase()}
                    value={widgets.all()}
                    boxClass="bg-all"
                    onFilter={() => onFilter(DocumentState.ALL)}
                />
                <Widget
                    icon="person_add"
                    title={I18nUtils.tr('TR_PENDIENTES').toUpperCase()}
                    value={widgets.pending()}
                    boxClass="bg-cyan"
                    onFilter={() => onFilter(DocumentState.PENDING)}
                />
                <Widget
                    icon="playlist_add_check"
                    title={I18nUtils.tr('TR_PENDIENTES_VALIDAR').toUpperCase()}
                    value={widgets.pendingValidation()}
                    boxClass="bg-orange"
                    onFilter={() => onFilter(DocumentState.PENDING_VALIDATION)}
                />
                <Widget
                    icon="help"
                    title={I18nUtils.tr('TR_CADUCADOS').toUpperCase()}
                    value={widgets.expired()}
                    boxClass="bg-gray"
                    onFilter={() => onFilter(DocumentState.EXPIRED)}
                />
                <Widget
                    icon="forum"
                    title={I18nUtils.tr('TR_RECHAZADOS').toUpperCase()}
                    value={widgets.rejected()}
                    boxClass="bg-pink"
                    onFilter={() => onFilter(DocumentState.REFUSED)}
                />
                <Widget
                    icon="forum"
                    title={I18nUtils.tr('TR_ARCHIVADOS').toUpperCase()}
                    value={widgets.archived()}
                    boxClass="bg-archived"
                    onFilter={() => onFilter(DocumentState.ARCHIVED)}
                />
                <Widget
                    icon="forum"
                    title={I18nUtils.tr('TR_NO_APLICA').toUpperCase()}
                    value={widgets.noApply()}
                    boxClass="bg-no-apply"
                    onFilter={() => onFilter(DocumentState.NO_APPLY)}
                />
            </div>
        );
    }

    dashboard = () => {
        const { companyManagement } = this.props;
        const request = new DashboardRequest(companyManagement);

        new DashboardTask(request)
            .onSuccess((res) => this.setState({ widgets: PsWidgets.fromAPIDashboard(res.data) }))
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

Widgets.propTypes = {
    onFilter: PropTypes.func.isRequired,
    companyManagement: PropTypes.string.isRequired,
};

Widgets.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/widgets/Widgets.jsx